/* eslint-disable */
/**
 * public/js/index.js
 * Fő kliensoldali belépési pont (Pug nézetekhez).
 * - Minden eseménykötés őrizve van (guard), így nincs "Cannot read property addEventListener of null".
 * - Axios import (ha Parcel bundle-ölsz → 'axios', ha nem → CDN-es import).
 * - Vizualizátor integráció: duplikáció-mentes rajzolás, frakciók, export.
 * - Kereső oldal: similarity UI guard, SMILES → CAS feloldás (POST /api/compounds/smiles/).
 */

// --- Axios import: válassz üzemmód szerint ---
//import axios from 'https://cdn.jsdelivr.net/npm/axios@1.9.0/+esm'; // ha közvetlenül a böngésző tölti
import axios from 'axios'; // ha Parcel bundler-rel fut

import { login, logout } from './login';
import { updateSettings } from './updateSettings';
import {
  plot,
  addCurve,
  addSelect,
  removeFractions,
  displayMethodParams,
} from './plot';
import * as visualizer from './visualizer';
import './compound-simulation';

console.log('>>> EZ FUT: public/js/index.js');

/* ============================================================================
   Segédfüggvények: biztonságos event-kötések
   ========================================================================== */
const on = (selectorOrEl, event, handler, options) => {
  const el =
    typeof selectorOrEl === 'string'
      ? document.querySelector(selectorOrEl)
      : selectorOrEl;
  if (el) el.addEventListener(event, handler, options);
  return el;
};

const onAll = (selector, event, handler, options) => {
  document
    .querySelectorAll(selector)
    .forEach((el) => el.addEventListener(event, handler, options));
};

/* ============================================================================
   Általános DOM referenciák
   ========================================================================== */
const loginForm = document.querySelector('.form--login');
const logOutBtn = document.querySelector('.nav__el--logout');
const userDataForm = document.querySelector('.form-user-settings');
const userPasswordForm = document.querySelector('.form-user-password');

const selectBtn = document.querySelectorAll('.btn--select');
const selectedCompounds = document.querySelector('.selection');
const chromatogram = document.querySelector('.plot');
const tableButtons = document.querySelector('.buttons');
const searchConatiner = document.querySelector('.search-body');
const visualizerInput = document.querySelector('.input--visualizer');
const totalAmount = document.getElementById('total-amount');
const table = document.getElementById('compounds-table');

const search = document.querySelector('.search-form');
const searchBtn = document.getElementById('search-btn-r');
const searchForm = document.querySelector('form[name="form"]');

const method = document.getElementById('method');

/* ============================================================================
   Login / Logout / Profil űrlapok
   ========================================================================== */
if (loginForm) {
  loginForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const email = document.getElementById('email')?.value || '';
    const password = document.getElementById('password')?.value || '';
    login(email, password);
  });
}

if (logOutBtn) {
  logOutBtn.addEventListener('click', logout);
}

if (userDataForm) {
  userDataForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = document.getElementById('name')?.value || '';
    const email = document.getElementById('email')?.value || '';
    updateSettings({ name, email }, 'data');
  });
}

if (userPasswordForm) {
  userPasswordForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const saveBtn = document.querySelector('.btn--save-password');
    if (saveBtn) saveBtn.textContent = 'Updating...';

    const passwordCurrent = document.getElementById('password-current')?.value || '';
    const password = document.getElementById('password')?.value || '';
    const passwordConfirm = document.getElementById('password-confirm')?.value || '';

    await updateSettings({ passwordCurrent, password, passwordConfirm }, 'password');

    if (saveBtn) saveBtn.textContent = 'Save password';
    ['password-current', 'password', 'password-confirm'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });
  });
}

/* ============================================================================
   Method mód (Elution / Elution-Extrusion) – Switch Time mező tiltása/engedése
   ========================================================================== */
if (method) {
  method.addEventListener('change', () => {
    const switchTimeNodes = document.querySelectorAll('.switchT');
    if (method.value === 'ex') {
      switchTimeNodes.forEach((el) => {
        el.classList.remove('form--disabled');
        el.disabled = false;
      });
    } else {
      switchTimeNodes.forEach((el) => {
        el.classList.add('form--disabled');
        el.disabled = true;
      });
      const st = document.getElementById('switch-time');
      if (st) st.value = 0;
    }
  });
}

/* ============================================================================
   Kereső oldali "Select" gombok – kiválasztás + ajánlók + "Simulate"
   ========================================================================== */
if (selectBtn && selectedCompounds && searchConatiner) {
  function handleClickSelect() {
    return async (e) => {
      e.preventDefault();

      const rowNode = e.target.closest('tr');
      if (!rowNode) return;

      const cas = rowNode.closest('.card')?.querySelector('.cas')?.innerText || '';

      let coi =
        rowNode.closest('.card')?.querySelector('h3 span')?.textContent?.trim() ||
        rowNode.closest('.card')?.querySelector('.heading-tertiary')?.textContent?.trim() ||
        rowNode.closest('.card')?.querySelector('.card__title')?.textContent?.trim() ||
        rowNode.children?.[0]?.textContent?.trim() ||
        '';

      const cells = rowNode.children;
      const solventSystem = cells?.[0]?.textContent?.trim() || '';
      const solventRatio = cells?.[1]?.textContent?.trim() || '';
      const kd = cells?.[3]?.textContent?.trim() || '';

      const simulateData = { solventSystem, solventRatio, compounds: [] };
      if (coi) simulateData.compounds.push({ compoundName: coi, kd });

      const h = document.createElement('h2');
      h.innerHTML = `Solvent System: ${solventSystem} in ${solventRatio} ratio <br> Sample Components:`;

      const list = document.createElement('ul');
      list.id = 'sample-components';
      if (coi) {
        list.innerHTML = `<li><strong>${coi} (CoI), K<sub>D</sub>= ${kd || 'N.A.'}</strong></li>`;
      }

      // töröld a korábbi keresési eredményt
      const oldResults = document.querySelector('.search-results.search-results--left');
      if (oldResults?.parentNode) oldResults.parentNode.removeChild(oldResults);

      try {
        const respSS = await axios.post('/api/compounds/sol-sys/', {
          solSys: solventSystem,
          solRatio: solventRatio,
          selfCas: cas,
        });

        if (respSS?.data?.status === 'success') {
          const tbl = document.createElement('table');
          tbl.classList.add('card__table-compound');

          const head =
            '<thead><tr><th>Compound Name</th><th>Solvent System</th><th>Solvent Ratio</th><th>Kd</th><th>Select</th></tr></thead><tbody>';
          const rows = [];

          for (const c of respSS.data.data) {
            const k = c.kd ? Number(c.kd).toFixed(2) : '';
            rows.push(
              `<tr>
                <td>${c.compoundName}</td>
                <td>${c.solSys}</td>
                <td>${c.ratio}</td>
                <td>${k}</td>
                <td><button class="btn btn--blue btn--xsmall btn--add-comp">Add</button></td>
              </tr>`
            );
          }
          rows.push('</tbody>');
          tbl.innerHTML = `${head}${rows.join('')}`;

          const container = document.createElement('div');
          container.classList.add('search-results', 'search-results--left');

          const heading = document.createElement('h2');
          heading.classList.add('heading-secondary');
          heading.textContent = 'CPC separations with the same solvent system';

          container.appendChild(heading);
          container.appendChild(tbl);
          searchConatiner.appendChild(container);

          container.querySelectorAll('.btn--add-comp').forEach((btn) => {
            btn.addEventListener(
              'click',
              (ev) => {
                const tr = ev.target.closest('tr');
                const tds = tr?.children || [];
                const compound = tds?.[0]?.textContent || '';
                const kd2 = tds?.[3]?.textContent || '';
                const li = document.createElement('li');
                li.innerHTML = `${compound}, K<sub>D</sub>= ${kd2}`;
                list.appendChild(li);
                ev.target.disabled = true;
                simulateData.compounds.push({ compoundName: compound, kd: kd2 });
              },
              { once: true }
            );
          });
        }
      } catch (err) {
        console.error('sol-sys fetch hiba:', err);
      }

      selectedCompounds.replaceChildren(h, list);

      const visForm = document.createElement('form');
      visForm.method = 'post';
      visForm.action = '/visualize';

      const visInput = document.createElement('input');
      visInput.type = 'hidden';
      visInput.name = 'data';

      const visBtn = document.createElement('button');
      visBtn.classList.add('btn', 'btn--blue', 'btn--simulate');
      visBtn.textContent = 'Simulate';

      visForm.appendChild(visInput);
      visForm.appendChild(visBtn);
      selectedCompounds.appendChild(visForm);

      visBtn.addEventListener('click', (ev) => {
        if (!simulateData.compounds.length) {
          ev.preventDefault();
          alert('Please add at least one compound.');
          return;
        }
        visInput.value = JSON.stringify(simulateData);
      });

      document.querySelectorAll('.btn--select').forEach((button) => {
        if (button === e.target) button.classList.add('btn--active');
        else {
          button.disabled = true;
          button.classList.add('btn--select:disabled');
        }
      });
    };
  }

  selectBtn.forEach((btn) =>
    btn.addEventListener('click', handleClickSelect(), { once: true })
  );
}

/* ============================================================================
   Vizualizátor oldal – rajzolás, frakciók, export
   ========================================================================== */
if (visualizerInput && chromatogram && table) {
  // Alap UI handlerek
  visualizer.inputHandleInstrumentDefaults();
  visualizer.inputHandleSf();

  const fractionsBox = document.querySelector('.fraction-table');
  if (fractionsBox) fractionsBox.style.display = 'none';

  // FRACTIONS PANEL MUTATÁSA
  on('#show-ft', 'click', () => {
    if (!fractionsBox) return;
    if (fractionsBox.style.display === 'none') {
      fractionsBox.style.display = 'block';
      const blocker = document.getElementById('block-compound');
      if (blocker?.style) blocker.style.display = 'block';
      const compTable = document.getElementById('compounds-table');
      if (compTable?.style) compTable.style.opacity = 0.4;
      const btns = document.querySelector('.compounds .buttons');
      if (btns?.style) btns.style.opacity = 0.4;
    }
  });

  // VISSZA GOMB
  on('.btn--back', 'click', () => {
    if (fractionsBox) fractionsBox.style.display = 'none';
    // frakciósávok törlése
    removeFractions({ plot_id: 'plot-1' });
    const blocker = document.getElementById('block-compound');
    if (blocker?.style) blocker.style.display = 'none';
    const compTable = document.getElementById('compounds-table');
    if (compTable?.style) compTable.style.opacity = 1;
    const btns = document.querySelector('.compounds .buttons');
    if (btns?.style) btns.style.opacity = 1;
  });

  // ADD COMPOUND
  if (tableButtons) {
    const addBtn = document.getElementById('add-button');
    if (addBtn) {
      let id = table.rows.length - 1;
      addBtn.addEventListener('click', () => {
        visualizer.addCompound(id);
        id += 1;
        visualizerInput.dispatchEvent(new Event('change'));
      });
    }
  }

  // REMOVE – delegált handler (mindenféle gombnévre)
  table.addEventListener('click', (e) => {
    const rm = e.target.closest('.delete-btn, .btn--remove, [data-action="remove"], [id^="delete-"]');
    if (!rm) return;
    e.preventDefault();
    rm.closest('tr')?.remove();
    visualizerInput.dispatchEvent(new Event('change'));
  });

  // <<< DELEGÁLT INPUT/CHANGE FIGYELŐK A TÁBLÁRA >>>
// Bármi lényeges mező változik → teljes újraszámítás + UI frissítés
  const reactIfCompoundField = (el) =>
    el.matches(
      '.mass-prop-input, [name="concentration"], [name="partition-coefficient"], [name="solubility-up"], [name="solubility-lp"], [name="compound-name"]'
    );

  table.addEventListener('input', (ev) => {
    if (reactIfCompoundField(ev.target)) {
      visualizerInput.dispatchEvent(new Event('change'));
    }
  });
  table.addEventListener('change', (ev) => {
    if (reactIfCompoundField(ev.target)) {
      visualizerInput.dispatchEvent(new Event('change'));
    }
  });
// <<< EDDIG >>>

// FŐ FUTTATÓ – runId + AbortController használat
  const runSimulation = async () => {
    const { runId, signal } = visualizer.beginRun();
    try {
      const settings = visualizer.getMethodSettings();

      // Total injected amount (mg)
      if (totalAmount) {
        const mg = settings.injectionVolume * settings.totalConcentration;
        totalAmount.innerText =
          mg > 1000
            ? `Total injected amount: ${(mg / 1000).toFixed(3)} g`
            : `Total injected amount: ${mg.toFixed(2)} mg`;
      }

      // Komponensek beolvasása
      const compounds = await visualizer.getCompounds(table, settings, signal, runId);
      if (!visualizer.isLatestRun(runId) || !Array.isArray(compounds) || compounds.length === 0) return;

      // --- Csúcselemzés (backend) + robusztus FWHM fallback ---
      const analyses = await Promise.all(
        compounds.map((c) => visualizer.analysePeak(c, settings, signal).catch(() => null))
      );

      // FWHM-ből számolt segéd (időben) – ha a backend nem adott mindent
      const fallbackFwhm = (pts) => {
        if (!pts || pts.length < 3) return { widthT: 0, apexT: 0 };
        let ymax = -Infinity, imax = 0;
        for (let i = 0; i < pts.length; i++) if (pts[i][1] > ymax) { ymax = pts[i][1]; imax = i; }
        const half = ymax / 2;

        // bal félmagasság-idő
        let tL = pts[0][0];
        for (let i = imax; i > 0; i--) {
          if (pts[i-1][1] <= half && pts[i][1] >= half) {
            const [t1,t2,y1,y2] = [pts[i-1][0], pts[i][0], pts[i-1][1], pts[i][1]];
            tL = t1 + (half - y1) * (t2 - t1) / (y2 - y1); break;
          }
        }
        // jobb félmagasság-idő
        let tR = pts[pts.length-1][0];
        for (let i = imax; i < pts.length - 1; i++) {
          if (pts[i][1] >= half && pts[i+1][1] <= half) {
            const [t1,t2,y1,y2] = [pts[i][0], pts[i+1][0], pts[i][1], pts[i+1][1]];
            tR = t1 + (half - y1) * (t2 - t1) / (y2 - y1); break;
          }
        }
        return { widthT: Math.max(0, tR - tL), apexT: pts[imax][0] };
      };

      // visszaírás a komponensekbe
      analyses.forEach((res, i) => {
        const c = compounds[i];
        if (res && visualizer.isLatestRun(runId)) {
          c.peakApex     = res.peakApex ?? res.rtApex ?? res.apexRt ?? c.peakApex ?? null;
          const wVol     = res.widthVolume ?? res.peakWidthVol ?? res.Wv ?? null;
          const wHalfT   = res.widthHalfTime ?? res.fwhmTime ?? null; // ha időben jött
          c.widthVolume  = wVol ?? (wHalfT ? wHalfT * settings.flowRate : c.widthVolume ?? null);
          c.thPlates     = res.thPlates ?? res.N ?? c.thPlates ?? null;
        }
        // Fallback, ha hiányos
        if (!c.widthVolume || !c.peakApex || !c.thPlates) {
          const { widthT, apexT } = fallbackFwhm(c.dataPoints);
          if (!c.peakApex) c.peakApex = apexT;
          const Wt = widthT;                            // [min]
          const Wv = Wt * settings.flowRate;            // [mL]
          if (!c.widthVolume) c.widthVolume = Wv > 0 ? Wv : null;
          // Lemezszám (FWHM képlet)
          if (!c.thPlates && Wt > 0 && c.rt > 0) {
            c.thPlates = 5.54 * Math.pow(c.rt / Wt, 2);
          }
        }
      });

      // Max jel magasság a skálához
      const maxConc = Math.max(...compounds.map((d) => d.height));

      // Plot beállítások
      const chromatogramSettings = {
        plot_id: 'plot-1',
        width: 800,
        height: 600,
        padding: 60,
        xMax: settings.runtime,
        yMax: maxConc + 5,
        outClass: 'chrom',
        textClass: 'plot__label',
        colors: [
          'rgb(64,64,65)',   // 0 → kontúr/sum
          'rgb(0,81,127)',   // 1
          'rgb(0,225,190)',  // 2
          'rgb(109,110,113)',// 3
          'rgb(50,188,173)', // 4
          'yellow',          // 5
          'orange',          // 6
          'red',             // 7
        ],
      };

      // Alap plot
      plot(chromatogram, chromatogramSettings);

      // Görbék + export + összeg görbe
      const eCompounds = [];
      const sumValues = [];
      let first = true;

      for (const [idx, c] of compounds.entries()) {
        addCurve(c.compoundName, c.dataPoints, idx + 1, 'path', chromatogramSettings);

        const d = c.dataPoints.slice();
        d.unshift([`Time_${c.compoundName}`, `Concentration_${c.compoundName}`]);
        eCompounds.push(d);

        for (let i = 0; i < c.dataPoints.length; i++) {
          const t = c.dataPoints[i][0];
          const y = c.dataPoints[i][1];
          if (first) sumValues.push([t, y]);
          else sumValues[i][1] += y;
        }
        first = false;
      }

      // Metódus jelölések
      displayMethodParams(settings, chromatogramSettings);

      // Csúcssorrend + RS (már van widthVolume + k)
      visualizer.calcPeakOrder(compounds);
      for (const el of compounds) {
        for (const other of compounds) {
          if (other.orderNo === el.orderNo + 1) {
            el.rsNext =
              (2 * ((other.peakApex - el.peakApex) * settings.flowRate)) /
              (el.widthVolume + other.widthVolume);
            el.selNext = other.k / el.k;
          }
          if (other.orderNo === el.orderNo - 1) {
            el.rsPrev =
              (2 * ((el.peakApex - other.peakApex) * settings.flowRate)) /
              (el.widthVolume + other.widthVolume);
            el.selPrev = el.k / other.k;
          }
        }
      }

      // Peak details – teljes újrarajzolás
      visualizer.renderPeakDetails(compounds, runId);

      // Összeg görbe
      addCurve('Sum Concentration', sumValues, 0, 'line', chromatogramSettings);

      // Frakciók + nézetválasztó
      const compNames = compounds.map((d) => d.compoundName);
      visualizer.handleFractions(compounds, settings, chromatogramSettings, runId);
      addSelect('#view-selector', 'plot-1', compNames);

      // Export gomb
      const exportBtn = document.querySelector('.btn--export');
      if (exportBtn) exportBtn.onclick = () => visualizer.exportData?.(eCompounds);
    } catch (err) {
      if (err?.name !== 'CanceledError' && err?.message !== 'canceled') {
        console.error('Visualizer change hiba:', err);
      }
    } finally {
      visualizer.endRun(runId);
    }
  };

// Változásra futtassuk (debounce-olva is lehetne)
  visualizerInput.addEventListener('change', runSimulation);
// induló futás
  visualizerInput.dispatchEvent(new Event('change'));
}
/* ============================================================================
   Kereső űrlap – similarity opció + SMILES → CAS feloldás
   ========================================================================== */
if (search) {
  let similarity = false;
  const chkSimilarity = document.getElementById('similarity');
  const compName = document.querySelector('input[value="compoundName"]');
  const radioSmiles = document.querySelector('input[value="smiles"]');

  let searchByVal = document.querySelector('input[name="searchBy"]:checked')?.value;

  document.querySelectorAll('input[name="searchBy"]').forEach((r) =>
    r.addEventListener('change', () => {
      searchByVal = document.querySelector('input[name="searchBy"]:checked')?.value;
    })
  );

  if (chkSimilarity) {
    chkSimilarity.addEventListener('change', (e) => {
      if (!searchForm) return;
      if (e.target.checked) {
        similarity = true;
        searchForm.setAttribute('method', 'POST');
        if (compName) compName.disabled = true;
        if (radioSmiles) {
          radioSmiles.checked = true;
          radioSmiles.dispatchEvent(new Event('change'));
        }

        if (!document.getElementById('sim-cont')) {
          const threshold = document.createElement('input');
          threshold.type = 'number';
          threshold.classList.add('form__input', 'similarity', 'input--similarity');
          threshold.name = 'threshold';
          threshold.id = 'threshold';
          threshold.min = 0;
          threshold.max = 1;
          threshold.step = 0.01;
          threshold.value = 0.9;

          const label = document.createElement('label');
          label.classList.add('form__label--sim', 'similarity');
          label.setAttribute('for', 'threshold');
          label.innerText = 'Threshold:';

          const container = document.createElement('div');
          container.id = 'sim-cont';
          container.appendChild(label);
          container.appendChild(threshold);

          document
            .querySelector('.form__elem--similarity')
            ?.appendChild(container);
        }
      } else {
        similarity = false;
        if (compName) compName.disabled = false;
        document.getElementById('sim-cont')?.remove();
        searchForm.setAttribute('method', 'GET');
      }
    });
  }

  if (searchBtn) {
    searchBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!searchForm) return;

      if (similarity) {
        // hasonlósági keresés szerveroldalon (POST)
        searchForm.submit();
      } else {
        // alap keresés – ha SMILES alapon keresünk, előbb feloldjuk CAS-re
        const searchByVal =
          document.querySelector('input[name="searchBy"]:checked')?.value;

        if (searchByVal === 'smiles') {
          const q = document.querySelector('input[name="q"]')?.value || '';
          const cas = await getCasFromSmiles(q);
          if (cas) {
            window.location.href = `/search/?q=${encodeURIComponent(
              cas
            )}&searchBy=cas`;
          } else {
            // ha nem sikerült CAS-t feloldani, essünk vissza a normál submitra
            searchForm.submit();
          }
        } else {
          searchForm.submit();
        }
      }
    });
  }
}

/* ============================================================================
   SMILES → CAS feloldás
   ========================================================================== */
const getCasFromSmiles = async (s) => {
  try {
    const resp = await axios({
      method: 'POST',
      url: '/api/compounds/smiles/',
      data: { smiles: s },
    });
    if (resp?.data?.status === 'success') {
      return resp.data.data.compound.cas;
    }
  } catch (err) {
    console.error('getCasFromSmiles hiba:', err);
  }
  return '';
};